import React from 'react';

const t = {
  unit: {
    ES: 'km',
    UK: 'mi',
    FR: 'km',
    NL: 'km',
    EU: 'km',
  },
};

const countryField = {
  ES: 'distance',
  UK: 'distanceMiles',
  FR: 'distance',
  NL: 'distance',
  EU: 'distance',
};

const DistanceCell = ({ distance, country, distanceMiles }) => {
  const data = { distance, distanceMiles };

  const distanceParsed = parseInt(data[countryField[country]], 10);

  if (isNaN(distanceParsed)) {
    return null;
  }

  return (
    <>
      {distanceParsed} {t.unit[country]}
    </>
  );
};

export default DistanceCell;
